<!--
    Summary:
        firstchoice.exhibition.web - mthfr-p12
    ChangeLog:
        wangn on 2020/12/6 added
-->
<template>
  <div class="v-mthfr-p12" title="mthfr-p12">
    <img-card>
      <div slot="title" style="width:100%;">{{$t('Mthfr.P12_1_Title')}}</div>
      <ul>
        <li>{{$t('Mthfr.P12_1_1')}}</li>
      </ul>
    </img-card>
    <img-card>
      <div slot="title" style="width:100%;">{{$t('Mthfr.P12_2_Title')}}</div>
      <ul>
        <li>{{$t('Mthfr.P12_2_1')}}</li>
      </ul>

      <!-- {{$t('Mthfr.P12_2_1')}} -->
    </img-card>
  </div>
</template>

<script>
  import ImgCard from "../img-card";

  export default {
    name: "mthfr-p12",
    components: {ImgCard}
  }
</script>

<style  lang="scss">
  .v-mthfr-p12 {
    display: flex;
    width: 1200px;
    margin: 0 auto;

    .v-card{
      width: 50%;
      .v-card-main{
        width: 600px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/genedetection/mthfr/mthfr-p12.vue